<script setup lang="ts">
import lastPageBgCity from '@/assets/img/home/lastPage/lastPage-bg-city.png'
import lastPageBgPeopleSvg from '@/assets/svg/home/lastPage/lastPage-bg-people.svg'
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import ContactDialog from "@/components/dialog/ContactDialog.vue";
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const boxRef = ref<HTMLElement | null>(null);
const serviceDialogRef=ref();
let observer: IntersectionObserver | undefined; // ✅ 提前定义 observer
onBeforeUnmount(() => {
  observer?.disconnect(); // ✅ 这里就能访问到上面的 observer
});

onMounted(async () => {
  await nextTick();

  const els = boxRef.value?.querySelectorAll<HTMLElement>("[data-anim]") ?? [];

  const OBS_IN = 0.05;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const el = e.target as HTMLElement;
      if (e.intersectionRatio >= OBS_IN) {
        el.dataset.inview = "true";
      } else if (e.intersectionRatio === 0) {
        el.dataset.inview = "false";
      }
    });
  }, {
    rootMargin: "0px 0px -15% 0px",
    threshold: [0, OBS_IN],
  });

  els.forEach((el) => observer.observe(el));
});
const openServiceDialog=()=>{
  serviceDialogRef.value.showServiceDialog();
}
</script>

<template>
    <div ref="boxRef" class="relative w-full bg-main-primary">
        <div  class="h-[19.375rem] relative overflow-hidden">
            <div  data-anim class="h-[19.375rem] relative overflow-hidden">
                <div class="relative z-10 flex flex-col items-center pt-[3.75rem]">
                    <!-- 大标题 -->
                    <div
                     data-anim
                     style="--d:100ms"
                     class="text-[3rem] text-center font-[600] text-white mb-[0.5rem]">
                        {{ t('footer.slogan.line1') }}
                    </div>
                    <!-- 副标题 -->
                    <div 
                     data-anim
                     style="--d:150ms"
                     class="text-[1.25rem] text-center font-[600] text-white mb-[2.5rem]">
                        {{ t('footer.slogan.line2') }}
                    </div>
                    <!-- 咨询按钮 -->
                    <button
                    data-anim
                    @click="openServiceDialog"
                    style="--d:200ms"
                        class="hover-button cursor-pointer text-white !border-[#fff] !border-[1px] !px-[3.75rem] !py-[1rem] !rounded-[3.125rem] !text-[1.25rem] font-[600]">
                        {{ t('footer.action.consult') }}
                    </button>
                </div>
            </div>
            <img :src="lastPageBgCity" class="absolute left-[5.625rem] bottom-0 object-cover w-[21.06rem] h-[10.875rem]"
                alt="city background" />
            <lastPageBgPeopleSvg class="absolute right-[6.3125rem] bottom-0 object-cover w-[19.19rem] h-[13.1875rem]" />
     
        </div>
        <ContactDialog ref="serviceDialogRef" />
    </div>
</template>

<style scoped>
.qrcode-box-shadow {
    background: rgba(255, 255, 255, 0.01);
    border: 0.42px solid rgba(255, 255, 255, 0.3);
    box-shadow: inset 0px 1.68px 4.19px 0px rgba(255, 255, 255, 0.5);
}

.hover-button {
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.hover-button:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.footer-link {
    color: rgba(255, 255, 255, 0.6);
    font-size: 1rem;
    transition: all 0.3s ease;
    cursor: pointer;
}

.footer-link:hover {
    color: rgba(255, 255, 255, 0.9);
    transform: translateX(4px);
}

[data-anim] {
  --d: 0ms;                                
  opacity: 0;
  transform: translateY(40px);
  transition:
    opacity 0.7s cubic-bezier(.25,.8,.25,1) var(--d),
    transform 0.7s cubic-bezier(.25,.8,.25,1) var(--d);
  will-change: opacity, transform;
}
[data-anim][data-inview="true"] {
  opacity: 1;
  transform: translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  [data-anim] {
    transition: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
</style>